import { render } from "./SideView.vue?vue&type=template&id=655f8647&scoped=true"
import script from "./SideView.vue?vue&type=script&lang=js"
export * from "./SideView.vue?vue&type=script&lang=js"

import "./SideView.vue?vue&type=style&index=0&id=655f8647&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-655f8647"

export default script